import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataService } from './../../../../services/data.service';
import { VendorService } from './../../../../services/vendor.service';
import { VendorPaymentDetails } from '../../../../models/VendorPaymentDetails';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-payments-view',
  templateUrl: './payments-view.component.html',
  styleUrls: ['./payments-view.component.scss']
})
export class PaymentsViewComponent implements OnInit, OnDestroy {
  userInfo:any;
  public searchText: string = '';
  vendorPayments:any;
  public alive: boolean = true;
  public ItmPerPage: any = [{ id: 1, name: '10', value: '10 per page' },
  { id: 2, name: '25', value: '25 per page' },
  { id: 3, name: '50', value: '50 per page' }];
  paymentsPg: number = 1;
  selectedPaymentPerPageVal = '10 per page';
  paymentsFilter: string = '';
  paymentSortBy: any = 'Date';
  paymentSortOrder: string = 'asc';
  vendorPaymentDetails: VendorPaymentDetails;
  recordCount: number;
  constructor(private datasvc: DataService, private vendorsvc: VendorService) { }

  ngOnInit() {
    this.userInfo = this.datasvc.userDisplayInfo;
    this.getPayments();
  }

  getPayments() {
    this.vendorsvc.getVendorPayments(this.searchText, this.userInfo.GPVID).takeWhile(() => this.alive).subscribe(
      payments => {
        this.vendorPayments = payments;
        console.log('Vendor data', this.vendorPayments);
        console.log('vendor pymt count', this.vendorPayments.length);
        this.recordCount = this.vendorPayments.length;
      });
  }

  getVendorPaymentDetails(encPymnt: string): any {
    console.log('pymnt', encPymnt);
     this.vendorPaymentDetails = new VendorPaymentDetails();
    this.vendorsvc.getVendorPaymentDetails(encPymnt, this.userInfo.GPVID).takeWhile(() => this.alive).subscribe(
      data => {
        this.vendorPaymentDetails = data;
        console.log('Vendor data', this.vendorPayments);

      },

     err => {
       console.log(err);
     }
    );
      return this.vendorPaymentDetails;
  }

  ngOnDestroy() {
    this.alive = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/payments-view/payments-view.component.ts